export function isProApp() {
    return false;
}
